// 申请时可选的关系类型list
export const RELATION_TYPE_LIST = [
  {
    label: '关联共享',
    value: '1',
  },
  {
    label: '关联分配',
    value: '2',
  },
]
// 审批操作
export const APPROVAL_ACTION_OBJ = {
  PASS: 1,
  REJECT: 2,
}
